import React from 'react';
import { Tooltip } from 'antd'; // Import Tooltip from antd

interface FilterProps {
  name?: string;
  handleSearch?: (searchValue: string) => void;
  setSearchValue?: (value: string) => void;
  searchValue?: string;
}

const Filter: React.FC<FilterProps> = ({ name, handleSearch, setSearchValue, searchValue }) => {

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (setSearchValue) {
      setSearchValue(e.target.value);
    }
  };
  
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && handleSearch && searchValue) {
      handleSearch(searchValue); // Trigger handleSearch on Enter key press
    }
  };


  const handleButtonClick = () => {
    if (handleSearch && searchValue) {
      handleSearch(searchValue); // Pass the current searchValue to handleSearch
    }
  };


  const handleResetButtonClick = () => {
    if (setSearchValue) {
      setSearchValue('');
    }
    if (handleSearch) {
      handleSearch('');
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Tooltip title={<span style={{ fontStyle: "italic" }}>Search based on name and email</span>}> 
        <input
          type="text"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown} // Add onKeyDown event listener
          placeholder="Search"
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </Tooltip>
      <Tooltip title="Click to search">
        <button
          className="gradient-button p-2.5 rounded-[5px]"
          onClick={handleButtonClick} // Use the corrected handler
        >
          Search
        </button>
      </Tooltip>
      <Tooltip title="Click to Reset">
        <button
          className="gradient-button p-2.5 rounded-[5px]"
          onClick={handleResetButtonClick} // Use the corrected handler
        >
          Reset
        </button>
      </Tooltip>
    </div>
  );
};

export default Filter;